import {
  AnnounceDetail as GQLItem,
  Category as GqlCategory,
  Subcategory as GqlSubcategory,
  Type as GqlType,
} from '../../generated/graphql';
import * as CategorySummary from '../App/Genre/CategorySummary';
import * as Subcategory from '../App/Genre/Subcategory';
import * as Type from '../App/Genre/Type';
import * as EventArtist from '../Artist/EventArtist';
import * as AnnounceArtist from '../../events/AnnounceArtist';
import * as TrackingEntry from './TrackingEntry';
import * as AnnounceAttachment from './AnnounceAttachment';
import { TicketsUrlType } from '../App/Announce/TicketsUrlType';
import { take } from '../../util';

// Re-exported, not redeclared: the announce save API owns this enum now. See
// `src/api/App/Announce/TicketsUrlType.ts`.
export { TicketsUrlType };

// TODO: This is just for ticket printing. More fields may be needed later.
export type AnnounceDetail = {
  id: number;
  promoter: string;
  support: string;
  description?: string;
  eventId?: number;
  eventName?: string;
  status?: string;
  tags?: string[] | string;
  ticketsUrl?: string;
  ticketsUrlType?: TicketsUrlType;
  defaultTicketsUrl?: string;
  handstampUrl?: string;
  announceAt?: string;
  buttonText?: string;
  type?: Type.Type;
  category?: CategorySummary.CategorySummary;
  subcategory?: Subcategory.Subcategory;

  eventArtists?: EventArtist.EventArtist[];
  announceArtists?: AnnounceArtist.AnnounceArtist[];
  tracking?: TrackingEntry.TrackingEntry[];
  attachments?: AnnounceAttachment.AnnounceAttachment[];
};

export const fromGql = (item: GQLItem): AnnounceDetail => ({
  ...take<AnnounceDetail>(item, 'id', 'promoter', 'support', 'description', 'eventId', 'eventName', 'status', 'tags', 'ticketsUrl', 'defaultTicketsUrl', 'handstampUrl', 'announceAt', 'buttonText'),
  ticketsUrlType: item.ticketsUrlType as TicketsUrlType | undefined,
  type: item.type ? Type.fromGql(item.type as GqlType) : undefined,
  category: item.category ? CategorySummary.fromGql(item.category as GqlCategory) : undefined,
  subcategory: item.subcategory ? Subcategory.fromGql(item.subcategory as GqlSubcategory) : undefined,
  eventArtists: item.eventArtists?.map(EventArtist.fromGql) || [],
  announceArtists: item.announceArtists?.map(AnnounceArtist.fromGql) || [],
  tracking: item.tracking?.map(TrackingEntry.fromGql) || [],
  attachments: item.attachments?.map(AnnounceAttachment.fromGql) || [],
});
